let sizecodedimensions = {
  20: { 75: 875, 80: 925, 85: 975, 90: 1025, 100: 1125 },
  21: { 75: 875, 80: 925, 85: 975, 90: 1025, 100: 1125 },
  22: { 75: 863, 80: 913, 85: 963, 90: 1013, 100: 1113 },
  23: { 75: 863, 80: 913, 85: 963, 90: 1037, 100: 1113 },
  30: { 75: 911, 80: 961, 85: 1011, 90: 1061, 100: 1161 },
  31: { 75: 911, 80: 961, 85: 1011, 90: 1061, 100: 1161 },
  32: { 75: 886, 80: 936, 85: 986, 90: 1036, 100: 1136 },
  41: { 75: 933, 80: 983, 85: 1033, 90: 1083 },
  60: { 75: 933, 80: 983, 85: 1033, 90: 1016 },
  65: { 75: 933, 80: 983, 85: 1033, 90: 1016 },
  70: { 75: 933, 80: 983, 85: 1033, 90: 1016 },
  75: { 75: 933, 80: 983, 85: 1033, 90: 1016 },
  80: { 90: 1020 },
  81: { 90: 1020 },
  82: { 90: 1057 },
  83: { 90: 1057 },
  85: { 90: 1020 },
  86: { 90: 1020 },
  87: { 90: 1057 },
  88: { 90: 1057 },
  520: { 90: 1042 },
  521: { 90: 1028 },
  522: { 90: 1051 },
  661: { 90: 1114 },
};

export default sizecodedimensions;
